export interface IEpiProps {
    selectCalendarText: string;
    showCalendarText: string;
}

export const DefaultEpiProps = {
    selectCalendarText: '', 
    showCalendarText: '', 
}